<template>
  <v-dialog @input="toggleModal"
            max-width="500"
            :value="value">
    <v-card color="kbLight">
      <v-toolbar color="kbPink"
                 dark
                 dense
                 flat>
                <span class="text-h6">
                    {{$t('general.assignOrSelectTheNameFromTheList')}}
                </span>
        <v-spacer/>
        <v-btn @click="toggleModal()"
               icon>
          <v-icon>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-row>
            <v-col cols="12" v-if="!isNewList && !addSelectedUsersToList">
              <v-switch hide-details
                        color="kbBlue"
                        :label="$t('general.AddPeopleToAnExistingList')"
                        :readonly="addSelectedUsersToList"
                        v-model="addToList">
              </v-switch>
            </v-col>

            <v-col cols="12" class="pb-0" v-if="addToList">
              <span class="kbDarkBlueText--text">
                {{ $t('general.note') }}: {{ $t('general.onlyStaticListsAreListedBelow') }}
              </span>
            </v-col>

            <v-col cols="12" v-if="addToList">
              <v-autocomplete v-model="selectedList"
                              item-color="kbDarkBlueText"
                              item-text="name"
                              item-value="_id"
                              :items="staticLists"
                              :label="$t('general.noList')"
                              :rules="[rules.required]"
                              :search-input.sync="searchListPersons"
              />
            </v-col>

            <v-col cols="12" v-if="!addToList">
              <v-text-field v-model="listName"
                            color="kbDarkBlueText"
                            :label="$t('general.listName')"
                            :rules="[rules.required]"
                            @keyup.enter="functionToCall" />
            </v-col>

            <v-col cols="12" v-if="!isNewList && !addToList && !addFromEventAttendees">
              <v-select v-model="listType"
                        color="kbDarkBlueText"
                        :items="listTypes"
                        :label="$t('general.listType')"
                        :rules="[rules.required]" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn outlined
               color="red"
               class="mr-1"
               @click="toggleModal(false)">
          {{$t('general.cancel')}}
        </v-btn>
        <!--importerProgress.index < createList.totalUsers - previous loading-->
        <v-btn color="kbPink"
               dark
               @click="functionToCall"
               :loading="loadingSubmit">
          {{addToList ? $t('general.updateList') : $t('general.createList')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import listPeopleService from '@/services/listsPersonsService'
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapGetters(['token', 'appUuid', 'companyUuid']),
    ...mapState({
      lists: state => state.listsPersons.listsPersons,
      importerProgress: state => state.listsPersons.importerProgress,
      usersSearch: state => state.users.search,
      advancedSearch: state => state.users.advancedSearch
    }),
    addSelectedUsersToList () {
      return !!(this.selectedUsersIds &&
        Array.isArray(this.selectedUsersIds) &&
        this.selectedUsersIds.length)
    },
    functionToCall () {
      if (this.isNewList) return this.createEmptyList
      return this.addToList ? this.updateList : this.createList
    },
    foundListName () {
      if (!this.listName || !Array.isArray(this.lists) || this.lists.length === 0) return false
      return Boolean(this.lists.find(item => item.name.toLowerCase() === this.listName.toLowerCase()))
    },
    listTypes () {
      return [
        { text: this.$t('general.static'), value: 'static' },
        { text: this.$t('general.dynamic'), value: 'dynamic' }
      ]
    },
    searchListPersons: {
      get () {
        return this.$store.state.listsPersons.searchListsPersons
      },
      set (value) {
        this.$store.commit('SET_SEARCH_LISTS_PERSONS', value)
      }
    },
    staticLists () {
      return this.lists.filter(item => item.type === 'static')
    }
  },
  data () {
    return {
      addToList: false,
      listName: '',
      listType: 'static',
      importedFrom: 'users',
      loadingSubmit: false,
      rules,
      selectedList: ''
    }
  },
  methods: {
    clearForm () {
      this.$refs.form.reset()
      this.listType = 'static'
      this.addToList = false
    },
    async createList () {
      try {
        if (!this.listName.trim()) return notifications.error(this.$t('general.addTheNameOfTheListToBeCreated'))
        if (this.foundListName) return notifications.error(this.$t('general.aListWithThisNameAlreadyExists'))
        if (!this.$refs.form.validate()) return
        let eventId
        let search = this.usersSearch
        if (this.addFromEventAttendees) {
          this.importedFrom = 'attendees'
          eventId = this.addFromEventAttendees
          search = {
            eventId
          }
        }
        this.loadingSubmit = true
        const response = await this.$store.dispatch('createList', { listName: this.listName, listType: this.listType, importedFrom: this.importedFrom })
        await this.$store.dispatch('addUsersToList',
          {
            listId: response._id,
            search,
            advancedSearch: this.advancedSearch
          })
        // emit created list
        this.$emit('createdList', response)
        this.loadingSubmit = false
        this.toggleModal()
      } catch (e) {
        this.loadingSubmit = false
        notifications.error(e)
      }
    },
    async createEmptyList () {
      if (!this.listName.trim()) return notifications.error(this.$t('general.addTheNameOfTheListToBeCreated'))
      if (this.foundListName) return notifications.error(this.$t('general.aListWithThisNameAlreadyExists'))
      if (!this.$refs.form.validate()) return
      try {
        await this.$store.dispatch('createEmptyList', {
          companyId: this.companyUuid,
          appId: this.appUuid,
          listName: this.listName
        })
        await this.$store.dispatch('getListsPersons')
        this.toggleModal()
      } catch (e) {
        notifications.error(e)
      }
    },
    getListsPersons () {
      this.$store.commit(
        'SET_PAGINATION_LISTS_PERSONS',
        {
          page: 1,
          itemsPerPage: 50,
          sortBy: '',
          descending: ''
        }
      )
      this.$store.dispatch('getListsPersons')
    },
    toggleModal () {
      this.clearForm()
      this.$emit('input', false)
    },
    async updateList () {
      try {
        if (!this.$refs.form.validate() || this.loadingSubmit) return
        this.loadingSubmit = true
        let eventId
        let search = this.usersSearch
        if (this.addFromEventAttendees) {
          eventId = this.addFromEventAttendees
          search = {
            eventId
          }
        }
        if (this.addSelectedUsersToList) {
          await listPeopleService.addSelectedUsersToList(
            this.token,
            this.companyUuid,
            this.appUuid,
            this.selectedList,
            this.selectedUsersIds
          )
          this.$emit('clearSelectedUsers')
        } else {
          const response = await this.$store.dispatch('addUsersToList', {
            listId: this.selectedList,
            search,
            advancedSearch: this.advancedSearch
          })
          this.$emit('updatedList', response)
        }
        notifications.success(this.$t('general.usersSuccessfullyAddedToList'))
        this.loadingSubmit = false
        this.toggleModal()
      } catch (e) {
        this.loadingSubmit = false
        notifications.error(e)
      }
    }
  },
  props: {
    selectedUsersIds: {
      type: Array,
      default: () => []
    },
    isNewList: {
      type: Boolean,
      default: false
    },
    addFromEventAttendees: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchListPersons () {
      this.getListsPersons()
    },
    value (value) {
      if (value && this.addSelectedUsersToList) {
        this.addToList = true
      }
    }
  }
}
</script>
